/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';

import OutsideClickHandler from 'react-outside-click-handler';

import { Menu, Dropdown } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import Modal from '../Modal';
import Button from '../Button';

import { useGlobal } from '../../contexts/Global/context';

import menuStructure from '../Menu/menuStructure';

import Icon from '../Icons';

import defaultUserImage from '../../assets/default-user-image.png';
import logo from '../../assets/logo.png';

import { logout } from '../../utils';

import * as S from './styles';
import * as Styles from '../Inputs/styles';
import Input from '../Inputs/Input';
import Notification from './Notification';
import { checkAllowedRoute } from '../../utils/checkAllowedRoute';
import { getContatosPorContrato } from '../../services';

const menu = (
    <Menu>
        <Menu.Item key="0">
            <a onClick={logout}>Logout</a>
        </Menu.Item>
    </Menu>
);

function checkHasTerm({ termsList, searchingTerm }) {
    if (!termsList) return false;

    return termsList.some((term) => term.includes(searchingTerm));
}

function getPathsMenuByTerm(searchingTerm, dataGlobal) {
    const keys = [];

    menuStructure.forEach(({ childrens, link: parentLink, title, terms, ...restParent }) => {
        if (childrens) {
            const pathsFounded = childrens
                .filter(
                    (child) =>
                        (checkHasTerm({ termsList: child.terms, searchingTerm }) || !searchingTerm) &&
                        checkAllowedRoute({ path: `${parentLink}${child.link}`, dataGlobal })
                )
                .map(({ link, title: titleChild, ...restChild }) => ({
                    codigo: link,
                    parentLink,
                    nome: titleChild,
                    ...restChild,
                }));

            keys.push(pathsFounded);

            return;
        }

        if (checkHasTerm({ termsList: terms, searchingTerm }) || !searchingTerm) {
            keys.push({
                codigo: parentLink,
                nome: title,
                ...restParent,
            });
        }
    });

    return keys.flat().sort((a, b) => {
        if (a.nome > b.nome) {
            return 1;
        }
        if (a.nome < b.nome) {
            return -1;
        }
        // a must be equal to b
        return 0;
    });
}

function ContentHeader({ handleDrawerToggle }) {
    const dataGlobal = useGlobal();

    const { dataLogin, dataActiveContract, contrastTheme } = dataGlobal;

    const history = useHistory();

    const [nomeHome, setNomeHome] = useState('');
    const [isOnFocus, setIsOnFocus] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [searchField, setSearchField] = useState({
        id: 'searchTerms',
        label: '',
        options: getPathsMenuByTerm('', dataGlobal),
        placeholder: 'O que você está procurando?',
        icon: { name: 'search', type: 'round' },
    });

    useEffect(() => {
        setShowAlertModal(false);
    }, []);

    useEffect(() => {
        async function getName() {
            const response = await getContatosPorContrato(dataActiveContract.numero);

            const dadosContato = response.find(
                (dadosContatoLogin) => dadosContatoLogin.emailContato === dataLogin.email
            );

            if (dadosContato !== undefined) {
                setNomeHome(dadosContato.nomeContato);
            } else {
                setNomeHome('');
            }
        }
        getName();
    }, []);

    useEffect(() => {
        const paths = getPathsMenuByTerm('', dataGlobal);

        setSearchField({ ...searchField, value: '', options: paths });
    }, [dataActiveContract]);

    function handleSearchTerms({ value }) {
        const paths = getPathsMenuByTerm(value, dataGlobal);

        setSearchField({
            ...searchField,
            value,
            options: paths,
        });
    }

    function handleSelectPath({ codigo, parentLink, externalLink }) {
        setIsOnFocus(false);

        if (externalLink) {
            window.open(externalLink, '_blank');

            return;
        }

        const path = parentLink && codigo ? `${parentLink}${codigo}` : '/';

        history.push(path);
    }

    function handleKeyDownOption({ event, dataOption }) {
        const $element = event.target;

        if ($element.tagName === 'LI' && ['Space', 'Enter'].includes(event.code)) {
            handleSelectPath(dataOption);

            return;
        }

        switch (event.code) {
            case 'ArrowUp':
                if ($element.previousElementSibling) {
                    $element.previousElementSibling.focus();
                }

                break;

            case 'ArrowDown':
                if ($element.nextElementSibling) $element.nextElementSibling.focus();
                break;

            case 'Escape':
                setIsOnFocus(false);
                break;

            default:
                break;
        }
    }

    return (
        <S.Container>
            <div className="hide-desktop">
                <div className="menu-info-mobile">
                    <Icon
                        type="round"
                        name="menu"
                        size={30}
                        color={contrastTheme ? '#FFFFFF' : '#8A8A8A'}
                        onClick={handleDrawerToggle}
                    />
                    <Link to="/">
                        <img className="logo-mobile" src={logo} alt="logo" />
                    </Link>
                </div>
            </div>

            <OutsideClickHandler
                onOutsideClick={() => {
                    if (isOnFocus) {
                        setIsOnFocus(false);
                    }
                }}
            >
                <S.ContainerSearchTerms>
                    <Input field={searchField} onChange={handleSearchTerms} onFocus={() => setIsOnFocus(true)} />

                    <Styles.ContainerOptions isOnFocus={isOnFocus}>
                        <ul>
                            {searchField.options.length === 0 && (
                                <li className="no-data-found">
                                    <span>Nenhuma opção encontrada...</span>
                                </li>
                            )}

                            {searchField.options.map(({ codigo, nome, ...rest }) => (
                                <li
                                    key={`${searchField.id}_${codigo}`}
                                    id={`${searchField.id}_${codigo}`}
                                    tabIndex="0"
                                    onKeyDown={(event) =>
                                        handleKeyDownOption({
                                            event,
                                            dataOption: { codigo, nome, ...rest },
                                        })
                                    }
                                    onClick={() => handleSelectPath({ codigo, nome, ...rest })}
                                >
                                    <S.TextInput>{nome}</S.TextInput>
                                </li>
                            ))}
                        </ul>
                    </Styles.ContainerOptions>
                </S.ContainerSearchTerms>
            </OutsideClickHandler>

            <S.UserInfo>
                <Notification />

                <img className="user-image" alt="user" src={defaultUserImage} />

                <Dropdown className="user-dropdown" overlay={menu} trigger={['click']}>
                    <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                        <div className="hide-mobile">
                            <span className="user-name">Olá, {nomeHome}</span>
                        </div>

                        <Icon name="ArrowDown" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                    </a>
                </Dropdown>
            </S.UserInfo>

            <Modal
                title="Atenção"
                visible={showAlertModal && dataActiveContract.isPme}
                onCancel={() => setShowAlertModal(false)}
                footer={null}
                style={{ maxWidth: 500 }}
            >
                <p>
                    Prezado Cliente,
                    <br />
                    <br />
                    Informamos que, devido a uma falha sistêmica, alguns boletos da competência de setembro/2022 foram
                    gerados duplicados e serão cancelados.
                    <br />
                    <br />
                    Caso tenha efetuado o pagamento e receba comunicados de cobrança e cancelamento, pedimos
                    desconsiderar.
                    <br />
                    <br />
                    Agradecemos a compreensão!
                </p>
                <Button type="primary" onClick={() => setShowAlertModal(false)}>
                    Estou ciente.
                </Button>
            </Modal>
        </S.Container>
    );
}

export default ContentHeader;
